import React from "react";
import { Button } from "antd";
import { Link, useNavigate } from "react-router-dom";
import IFM from "../../../assets/images/mira_error.png";
import { MIRA_LEARN_MORE_URL } from "./miraLinks";

const textStyle = {
  margin: "0 0 12px",
  color: "#595959",
  fontSize: 14,
  lineHeight: 1.5,
};

const linkStyle = { color: "#01ADF0", fontWeight: 600 };

export default function MiraAccountSetupMessage({
  maxTextWidth = "100%",
  imageMaxWidth = 280,
  style,
}) {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        boxSizing: "border-box",
        width: "max-content",
        maxWidth: "100%",
        ...style,
      }}
    >
      <div style={{ maxWidth: maxTextWidth }}>
        <p style={{ margin: "0 0 8px", color: "#01ADF0", fontSize: 16, fontWeight: 700 }}>
          Track Your Cycle with Mira Fertility
        </p>
        <p style={textStyle}>
          Mira is an optional fertility tracking tool that can help you
          monitor hormone and cycle patterns over time.
        </p>
        <p style={textStyle}>
          <a href={MIRA_LEARN_MORE_URL} target="_blank" rel="noopener noreferrer" style={linkStyle}>
            Learn more about Mira
          </a>
        </p>
        <p style={textStyle}>
          Already using Mira? Go to{" "}
          <Link to="/chart" style={linkStyle}>
            Chart
          </Link>{" "}
          to connect your Mira Fertility account.
        </p>
      </div>
      <Button
        type="primary"
        onClick={() => navigate("/chart")}
        style={{
          marginBottom: 16,
          backgroundColor: "#00ADEF",
          border: "1px solid #00ADEF",
        }}
      >
        Go to Mira Chart
      </Button>
      <img
        src={IFM}
        alt="Calendar illustration"
        style={{
          maxWidth: imageMaxWidth,
          width: "auto",
          height: "auto",
          display: "block",
        }}
      />
    </div>
  );
}
